import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};

export const DirectionIcon = ({ 
    stroke = 'currentColor', 
    strokeWidth = '2', 
    width = 28, 
    height = 28, 
    ...props 
}: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    
    return (
        <svg 
            width={scaleWidthPixel(width)} 
            height={scaleHeightPixel(height)} 
            viewBox="0 0 28 28" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg" 
            {...props}
        >
            <path 
                d="M3.76368 7.01953H17.8398C20.0688 7.01953 21.8758 8.8265 21.8758 11.0555C21.8758 13.2845 20.0688 15.0915 17.8398 15.0915H11.3741C9.14958 15.0915 7.34626 16.8948 7.34626 19.1193C7.34626 21.3438 9.14958 23.1471 11.3741 23.1471H16.3859" 
                stroke={stroke} 
                strokeWidth={strokeWidth}
            />
            <ellipse 
                cx="21.8764" 
                cy="23.1478" 
                rx="2.6498" 
                ry="2.6498" 
                stroke={stroke} 
                strokeWidth={strokeWidth}
            />
            <path 
                d="M7.08235 3L3 7.08235L7.08235 11.1647" 
                stroke={stroke} 
                strokeWidth={strokeWidth === '2' ? '1.75' : strokeWidth}
            />
        </svg>
    );
};